import { Dispatch, SetStateAction } from 'react';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { ace_index } from '@axo/shared/data-access/types';
import { ColumnID } from '../components/SearchResults';

interface State {
  query: ace_index.FindInput;
  columns: ColumnID[];

  actions: {
    replaceQuery: Dispatch<SetStateAction<State['query']>>;
    clearQuery: () => void;
    replaceColumns: Dispatch<SetStateAction<State['columns']>>;
  };
}

const useState = create<State>()(
  persist(
    (set) => ({
      query: {},

      columns: [
        'HumanReadableID',
        'Product',
        'Broker',
        'CompletedAt',
        'Status',
        'AppliedAmount',
        'FirstName',
        'LastName',
        'UpdatedAt',
        'Owner',
        'LockedBy',
      ],

      actions: {
        replaceQuery: (action) =>
          set((state) => ({
            query: typeof action === 'function' ? action(state.query) : action,
          })),

        clearQuery: () => set({ query: {} }),

        replaceColumns: (action) =>
          set((state) => ({
            columns:
              typeof action === 'function' ? action(state.columns) : action,
          })),
      },
    }),
    {
      name: 'ace.quicksearch',
      partialize: ({ actions: _, ...state }) => state,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const useQuickSearchQuery = () => useState((state) => state.query);

export const useQuickSearchColumns = () => useState((state) => state.columns);

export const useQuickSearchActions = () => useState((state) => state.actions);
